/**
 * https://www.pdftron.com/api/web/Core.DocumentViewer.html#setPagesUpdatedInternalAnnotationsTransform__anchor
 */
export default callback => {
  window.documentViewer.setPagesUpdatedInternalAnnotationsTransform(callback);
};
